import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorPage } from "routes/error/ErrorPage";
import { GuestRoute } from "./GuestRoute";
import { ProtectedRoute } from "./ProtectedRoute";
import { ProtectedRouteWrapper } from "./ProtectedRouteWrapper";
import { RouteConfig } from "./routeTypes";

type RouteWrapperProps = {
  guestRouteConfig: RouteConfig[];
  protectedRouteConfig: RouteConfig[];
  publicRouteConfig: RouteConfig[];
};

export const RouteWrapper: React.FC<RouteWrapperProps> = ({
  guestRouteConfig,
  protectedRouteConfig,
  publicRouteConfig,
}) => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <GuestRoute />,
      errorElement: <ErrorPage />,
      children: guestRouteConfig.map((element) => {
        return {
          path: element.path,
          element: <element.component />,
        };
      }),
    },
    ...publicRouteConfig.map((element) => {
      return {
        path: element.path,
        element: <element.component />,
      };
    }),
    {
      element: <ProtectedRoute />,
      errorElement: <ErrorPage />,
      children: protectedRouteConfig.map((element) => {
        return {
          path: element.path,
          element: (
            <ProtectedRouteWrapper config={element}>
              <element.component />
            </ProtectedRouteWrapper>
          ),
        };
      }),
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};
